<ngb-pagination
  [rotate]="true"
  [page]="page"
  [pageSize]="size"
  [collectionSize]="totalElements"
  (pageChange)="onPageSelect($event)"
  [maxSize]="5"
></ngb-pagination>
<select (change)="onSizeSelect($event.target.value)">
  <option *ngFor="let s of pageSizes" [value]="s" [selected]="size === s">{{ 'shared.pagination.items' | translate:{amount: s} }}</option>
</select>
